const _temp0 = require("../_shared/tag/skipToMain.view.js");
const _temp1 = require("../_shared/tag/skipToMain.view.less");
module.exports = {
  "js": _temp0,
  "less": _temp1
}